import { get } from 'lodash'
import { connect } from 'react-redux'

import { common, formData } from '../../../../constants/actions'
import withColorSetting from '../../../../hoc/withColorSettings'
import withUrlParams from '../../../../hoc/withUrlParams'
import {
  getCurrentRegistration,
  getDisplayPriceAsZero,
  getFeeConfigurations,
  getFormId,
  getFormInfo,
  getFormSettings,
  getFormType,
  getOrgTimezones,
  getPaymentGateways,
  getSessionId,
  getUserId,
} from '../../../../selectors'
import ProductComponent from './component'

const mapStateToProps = state => ({
  addOn: get(state, 'formInfo.addOn'),
  products: get(state, 'formInfo.products'),
  productGroups: get(state, 'formInfo.productGroups'),
  team: get(state, 'formInfo.team'),
  subEvents: get(state, 'formInfo.subEvents'),
  registrations: get(state, 'formData.registrations'),
  currentRegistration: getCurrentRegistration(state),
  sessionId: getSessionId(state),
  timezones: getOrgTimezones(state),
  formType: getFormType(state),
  feeConfigurations: getFeeConfigurations(state),
  paymentGateway: getPaymentGateways(state),
  formSettings: getFormSettings(state),
  displayPriceAsZero: getDisplayPriceAsZero(state),
  userId: getUserId(state),
  form: getFormId(state),
  formInfo: getFormInfo(state),
})

export default connect(mapStateToProps, {
  startTimer: common.setStartTimer,
  setValue: formData.setValues,
  setTeam: formData.setTeamValues,
  createAndValidateSession: formData.createAndValidateSession,
  validateSession: formData.validateSession,
})(withUrlParams(withColorSetting(ProductComponent)))
